<template>
  <div class="progres-bar" :data-value="objectif">
    <span
      v-if="minimum"
      class="minimum"
      :style="{ width: `${minimumPercentage}%` }"
      :data-value="minimum && minimumPercentage < 95 ? minimum : ''"
    ></span>
    <span
      class="progress"
      :style="{ width: `${percentage}%`, backgroundImage: `linear-gradient(to right, ${lightenColor}, ${progressColor}, ${progressColor}, ${darkenColor})` }"
    >
      <span
        class="score"
        :style="{ color: progressColor }"
      >{{ progress }}</span>
    </span>
  </div>
</template>

<script>
import { lightenDarkenColor } from '@/js/utils/lightenDarkenColor'

export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    objectif: {
      type: Number,
      defult: 100
    },
    minimum: Number,
    donemandatoryq: Number,
    mandatoryq: Number
  },

  data () {
    return {
      color: '#ffa700'
      // color: '#44d22d'
    }
  },

  computed: {
    // width percent
    percentage () {
      let percent = this.progress / this.objectif * 100 // pass the progression to 100%
      if (percent > 100) percent = 100
      return percent
    },
    minimumPercentage () {
      let percent = this.minimum / this.objectif * 100 // pass the minimum to 100%
      if (percent > 100) percent = 100
      return percent
    },

    // color and gradient
    progressColor () {
      const color = this.progress >= this.minimum &&
                    this.mandatoryq == this.donemandatoryq ?
                    '#44d22d' : '#ffa700'
      return color
    },
    lightenColor () { return lightenDarkenColor(this.progressColor, 55) },
    darkenColor () { return lightenDarkenColor(this.progressColor, -10) }
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@import '../../styles/components/progress/progress-bar';

</style>
